module.exports = "https://cache-nest.services.handy.com/packs/media/src/assets/images/handy_logo-0a725f80e4b53831f0e51a6a29adfad8.svg";